module.exports = __webpack_public_path__ + "static/media/user.81e1094e.svg";